import { Types } from '@jumpcloud/ui-components';

const { Column } = Types;

const EventTableColumns = [
  Column({
    dataFieldName: 'state',
    label: 'Type',
    sortable: 'false',
    width: '1fr',
  }),
  Column({
    dataFieldName: 'scheduledDate',
    label: 'Date/Time',
    sortable: 'false',
    width: '2fr',
  }),
  Column({
    dataFieldName: 'deleteIcon',
    label: '',
    sortable: 'false',
    width: '40px',
  }),
];

export default EventTableColumns;
